import {
  SNACKBAR_HIDE_MESSAGE,
  SNACKBAR_SHOW_MESSAGE,
} from '../action-types/snackbar-types';

export const snackbarShowMessage = payload => ({
  type: SNACKBAR_SHOW_MESSAGE,
  payload,
});

export const snackbarHideMessage = () => ({
  type: SNACKBAR_HIDE_MESSAGE,
});
